import React, { useEffect } from 'react'
import {useParams, useHistory} from 'react-router-dom'
import Layout from '../../components/Layout'
import {UseTmpOrder}  from '../../hooks/tmpOrder/useTmpOrder'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import TmpOrderForm from './TmpOrderForm'
import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core'
import { isArray, ROUTES, uploadFilesToAws, success } from '../../shared/constants'
import { API, backendUrl, tmpOrderUrl } from '../../shared/API'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTable from '../../components/Table/CustomTable'
import CustomButton from '../../components/CustomButton'
export default function AddTmpOrder({ currentOrder }) {
  const formSchema= {
    channelName: '',
    channelType: "",
    category: '',
    subCategory: '',
    qty: '',
    product: '',
    code: '',
    price: '',
  }
  const [orders, setOrders] = React.useState([])
  const [form, setform] = React.useState(formSchema)
  const [editForm, setEditForm] = React.useState(formSchema)
  const [price, setPrice] = React.useState(0);

  const history = useHistory();
  const {addTmpOrder, editTmpOrder, getAllTmpOrder, getSingleTmpOrder, tmpOrder, loading } = UseTmpOrder();
  const tableHeadings=['Code', 'Quantity', 'Sku', 'Price', 'Category', 'SubCategory', 'Channel Type', 'Sales Channel Type']

  const handleOrderSubmit = async () => {
    if(id.id !== undefined){
      console.log("editing")
      console.log(editForm);
      editTmpOrder({id: id.id, ...orders}, id.id)
    }
    else {
        addTmpOrder(
        {...orders}
      )
    history.push(ROUTES.MY_TMPORDERS)
    }
  } 

  const handleAdd = async () => {
    if(form.qty === 0 || form.category === null || form.subCategory === null || form.product === null){
      return;
    }
    if(id.id !== undefined){
    setOrders([...orders, form]);
    }
    else {
      setOrders([...orders, form]);
    }
    setform({...form, category: "", subCategory: "", product: "", qty: 0, price: 0})
    toastMessage('Order added to the list', success)
    // setOrders({
    //   ...orders, 
    //   product: orders.product.push(form.product),
    //   qty: orders.product.push(form.qty)
    // })
    
  } 
  const id= useParams()
  console.log("id", id)

  useEffect(()=>{
    if(id.id !== undefined ){
      let item= getSingleTmpOrder(id.id)
      console.log("single Order Edit", item);
      if(item.channelType){ 
        let n = item.product.length;
        let arr = [];
        console.log(n)
        
        for(let i =0; i<n; i++){
          arr =([...arr, {
            channelName: item.channelName._id,
            channelType:item.channelType._id,
            category: item.category[i]._id,
            subCategory: item.subCategory[i]._id,
            product: item.product[i]._id,
            qty: item.qty[i],
            code: item.code,
            price: item.price
          } ])
        }
        setOrders(arr) 

        console.log(arr)
      }
    }
  }, [id])

  useEffect(()=>{
    console.log("editForm", editForm)
  }, [editForm])
  useEffect(()=>{
    console.log("orders", orders)
  }, [orders])
  return (
    <Layout heading={`Orders`} heading2={` ${id.id !== undefined? 'Edit' : 'Add'}`} url1={ROUTES.MY_TMPORDERS} none>
      <HeaderTabLayout
        heading={ `${id.id!==undefined ? 'Edit' : 'Add'}  Order `}
        content={
          id.id == undefined 
          ?
          <TmpOrderForm 
            handleOrderSubmit = {handleOrderSubmit}
            orders = {orders}
            state={id.id !== undefined? form : form} setState={id.id !== undefined? setform : setform} 
            setOrders = {setOrders}
            setPrice = {setPrice}
             />
          : 
          orders.map((form)=> {
           return (<>
              <TmpOrderForm 
                  handleOrderSubmit = {handleOrderSubmit}
                  orders = {orders}
                  state={id.id !== undefined? form : form} setState={id.id !== undefined? setform : setform} 
                  setOrders = {setOrders}
                  edit = {true}
                  setPrice = {setPrice}
              />
              <hr/>
           </>)
          })
        }
        addContent={handleAdd}
        text={`${id.id!==undefined ? 'Update' : 'Add'}`}
        redirect={ROUTES.MY_TMPORDERS}
        loading={loading}
      />
          <br/>
          {orders.length !== 0 && <CustomTable>
        <CustomTableHeading heading={tableHeadings}/>
          <TableBody>
          { orders.map(order=>{
            return <TableRow>
                <TableCell>
                  {order.code}
                </TableCell>
                <TableCell>
                  {order.qty}
                </TableCell>
                <TableCell>
                  {order.product.sku}
                </TableCell>
                <TableCell>
                  {order.price}
                </TableCell>
                <TableCell>
                  {order.category.categoryName}
                </TableCell>
                <TableCell>
                  {order.subCategory.name}
                </TableCell>
                <TableCell>
                  {order.channelType.name}
                </TableCell>
                <TableCell>
                  {order.channelName.name}
                </TableCell>
                {/* <TableCell>
                  {order.channelName.name}
                </TableCell> */}

            </TableRow>
          })}
        </TableBody>
   
      </CustomTable>}

      {orders.length >0 && <CustomButton
          handleSubmit={
            handleOrderSubmit
          }
          text={"Submit"}
          style= {{alignSelf: "center", width: "100%", marginLeft: "20px", fontStyle: "cursive"}}
          noWidth
        />}
      
      {/* <button onClick={handleOrderSubmit}>Submit the orders</button> */}
    </Layout>
  )
}
